import { CheveronRightIcon, PersonIcon } from '@wkda/icons';
import type {
  HeaderAccountItem,
  UserSingleNavlistItem,
} from '../shared.types.js';

export function AccountMenu({
  isLoggedIn,
  accountItem,
  logoutItem,
  LinkComponent,
}: {
  isLoggedIn: boolean;
  accountItem?: HeaderAccountItem;
  logoutItem?: UserSingleNavlistItem;
  LinkComponent: any;
}) {
  return (
    <>
      {accountItem && isLoggedIn ? (
        logoutItem ? (
          <div className="wa-nav-vertical__item">
            <LinkComponent
              className="wa-nav-vertical__item-link"
              href={logoutItem?.link}
            >
              {logoutItem?.title}
            </LinkComponent>
          </div>
        ) : null
      ) : null}
      {accountItem ? (
        <div className="wa-nav-vertical__item wa-account-item">
          <LinkComponent
            className="wa-nav-vertical__item-link wa-account-link"
            href={accountItem?.link}
          >
            <PersonIcon />
            {accountItem?.title}
            <CheveronRightIcon />
          </LinkComponent>
        </div>
      ) : null}
    </>
  );
}
